<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col sm="5">
          <h4>
            Welcome {{ employee.name }} (<small>{{ employee.nik }}</small
            >), to MBS portal system
          </h4>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import VueNotifications from "vue-notifications";
import loading from "@/templates/Loading.vue";
import LineExample from "@/views/charts/LineExample.vue";
import DoughnutExample from "@/views/charts/DoughnutExample.vue";

import BarExample from "@/views/charts/BarExample.vue";
import * as moment from "moment";

import _ from "lodash";
export default {
  name: "dashboard-profile",
  components: {
    globalTable,
    Callout,
    loading,
    LineExample,
    DoughnutExample,
    BarExample,
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      employee: [],
      loading: true,
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("MMMM"),
      fields_suggest_visit: [
        { key: "name", label: "Nama Konsumen", sortable: true },
        { key: "last_order_date", label: "Last Order", sortable: true },
      ],
      fields_myorder: [
        { key: "order_number", label: "Order Number", sortable: true },
        { key: "total_price_plan", label: "Total", sortable: true },
      ],
      employee_id: [],
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    init: function () {
      this.axios
        .get("web/dashboard/profile/my-profile")
        .then((response) => {
          this.employee = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>


<style>
</style>